const adapter = {
  responseBodyToRender(input){
    let output = {}

    if(input){
      const {
        systemRowId,
        typeJoin,
        individu,
        statusRequest,
      } = input

      output = {
        id: systemRowId,
        type: typeJoin,
        sender: {
          id: individu.userId,
          name: individu.namaIndividu
        },
        status: {
          id: statusRequest.id,
          name: statusRequest.nama[0]
        }
      }
    }

    return output
  },
  responseBodyToIndividuForm(input){
    let output = {}

    if(input){
      const {
        id,
        typeJoin,
        organisasi,
        statusRequest,
      } = input

      output = {
        id,
        type: typeJoin,
        sender: {
          id: organisasi.organisasiId,
          name: organisasi.namaOrganisasi
        },
        status: {
          id: statusRequest.id,
          name: statusRequest.nama[0]
        }
      }
    }

    return output
  }
}

export default adapter
